
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recruitment",
      function () {
        return require("private-next-pages/recruitment.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recruitment"])
      });
    }
  